<template>
    <div class="relative w-full text-left">
        <label
            v-if="label"
            class="text-sm font-bold text-neutral-darkest transition-all duration-200"
        >
            {{ label }}
        </label>
        <div class="relative flex flex-col justify-center">
            <input
                class="h-12 w-full appearance-none rounded-lg border border-neutral-lighter px-4 py-3 font-normal placeholder-neutral outline-none transition-all duration-200 focus:ring-2 focus:ring-primary focus:ring-opacity-20 md:border-2"
                :class="[
                    {
                        'pl-12': icon,
                        'border-primary': !readonly && focused,
                        'bg-neutral-lightest': readonly && !background,
                        'rounded-r-none': noRightBorderRadius,
                    },
                    background,
                ]"
                :name="name"
                :autocomplete="name"
                :type="inputType"
                :placeholder="placeholder"
                :value="value"
                :min="min"
                :max="max"
                :readonly="readonly"
                @focus="
                    focused = true;
                    $emit('focus');
                "
                @blur="
                    focused = false;
                    $emit('blur');
                "
                @input="onInput"
            />
            <Icon
                v-if="icon"
                class="absolute left-0 ml-4 transition-all duration-200"
                :class="{
                    'text-primary': !readonly && focused,
                    'text-neutral-darkest': !focused,
                    'text-error': $store.getters.hasError(name, scope) || displayCustomError,
                }"
                :icon="['far', icon]"
            />
            <transition enter-class="opacity-0" leave-to-class="opacity-0">
                <Icon
                    v-if="type === 'password' && inputType === 'text'"
                    :icon="['far', 'eye']"
                    class="absolute right-0 mr-4 cursor-pointer text-xl text-primary transition-opacity duration-200"
                    @click="toggleInputType"
                />
            </transition>
            <transition enter-class="opacity-0" leave-to-class="opacity-0">
                <HideIcon
                    v-if="type === 'password' && inputType === 'password'"
                    class="absolute right-0 mr-4 cursor-pointer transition-opacity duration-200"
                    @click="toggleInputType"
                />
            </transition>
            <transition enter-class="opacity-0" leave-to-class="opacity-0">
                <div
                    v-if="$store.getters.hasError(name, scope)"
                    class="absolute bottom-0 left-0 max-w-full translate-y-full transform truncate text-xs text-error transition-all duration-200"
                >
                    {{ $store.getters.getError(name, scope) }}
                </div>
                <div
                    v-if="displayCustomError"
                    class="absolute bottom-0 left-0 max-w-full translate-y-full transform truncate text-xs text-error transition-all duration-200"
                >
                    {{ errorMessage }}
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import { VALIDATION_REMOVE_ERROR } from '@/constants';
import HideIcon from '@/assets/img/login-hide.svg';

@Component({
    components: {
        HideIcon,
    },
    props: {
        icon: String,
        label: String,
        placeholder: String,
        name: String,
        scope: {
            default: 'default',
            type: String,
        },
        type: {
            default: 'text',
            type: String,
        },
        min: {
            default: '0',
            type: String,
        },
        max: {
            default: '99',
            type: String,
        },
        value: [String, Number],
        debounced: Boolean,
        readonly: Boolean,
        background: String,
        noRightBorderRadius: Boolean,
        errorMessage: {
            default: '',
            type: String,
        },
    },
})
export default class InputText extends Vue {
    focused = false;
    inputType = 'text';

    mounted() {
        this.inputType = this.type;
    }

    toggleInputType() {
        this.inputType = this.inputType === 'text' ? 'password' : 'text';
    }

    get displayCustomError() {
        return this.errorMessage != undefined && this.errorMessage != '';
    }

    onInput(e) {
        if (this.$store.getters.hasError(this.name, this.scope)) {
            this.$store.commit(VALIDATION_REMOVE_ERROR, {
                field: this.name,
                scope: this.scope,
            });
        }

        if (this.debounced) {
            if (this.timeout) clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.$emit('input', e.target.value);
            }, 500);
        } else {
            this.$emit('input', e.target.value);
        }
    }
}
</script>
